enum LicenseRoutes {
  List = '/licenses',
  Edit = '/licenses/edit/:id',
  Add = '/licenses/add',
}

export default LicenseRoutes
